import React, { forwardRef, useEffect, useState } from 'react';

import TextInputV2 from 'common/ui/TextInputV2';
import subdomainify from 'common/util/subdomainify';

type SubdomainInputV2Props = Omit<
  React.ComponentProps<typeof TextInputV2>,
  'value' | 'defaultValue'
> & {
  defaultValue?: string;
  value: string;
};

const SubdomainInputV2 = forwardRef<HTMLInputElement, SubdomainInputV2Props>(
  (
    { defaultValue, value, suffix = '.canny.io', placeholder = 'Subdomain', onChange, ...props },
    ref,
  ) => {
    const [subdomain, setSubdomain] = useState(subdomainify(value));

    useEffect(() => {
      const subdomainified = subdomainify(value);
      setSubdomain(subdomainified);
      onChange?.(subdomainified);
    }, [value, onChange]);

    const handleOnChange = (newValue: string) => {
      const subdomainified = subdomainify(newValue);
      const finalValue = newValue === subdomainified + '-' ? newValue : subdomainified;

      setSubdomain(finalValue);
      onChange?.(subdomainified);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === ' ') {
        e.preventDefault();
      }

      props.onKeyDown?.(e);
    };

    return (
      <TextInputV2
        {...props}
        name="subdomain"
        ref={ref}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
        suffix={suffix}
        value={subdomain}
        placeholder={placeholder}
      />
    );
  },
);

export default SubdomainInputV2;
